<script>
  import ElectionTrends from './ElectionTrends.svelte';
  import GovernorSeats from './GovernorSeats.svelte';
  import GovernorLegend from './GovernorLegend.svelte';

  export let feed;

  // Width of the embed itself, not the browser window, so the layout
  // still switches to mobile inside a narrow CMS column
  /** @type {number | undefined} */
  let width;

  $: compact = width !== undefined && width <= 680;
</script>

<div class="governor-trends" bind:clientWidth={width}>
  <ElectionTrends
    {feed}
    level="governor"
    let:uncalled
  >
    <div class="governor-stage">
      <GovernorSeats {feed} />
      <GovernorLegend {uncalled} {compact} />
    </div>
  </ElectionTrends>
</div>
